import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'were_any_wrkrs_und_the_legal_minimum_working_age_when_hired'

export const dataPointDefinition = {
  retracedId: 'were_any_wrkrs_und_the_legal_minimum_working_age_when_hired',
  name: 'Were any workers under the legal minimum working age when hired?',
  description:
    'The intent of this question is to understand if any workers performing work for the facility are under the applicable legal minimum working age in the country in which the facility operates (including whether they were under the minimum working age when they were hired, even if they are above the minimum age at the time of assessment).\r\r\n\r\r\nThis question applies to all workers, including apprentices, trainees, interns, etc.\r\r\n\r\r\nA worker is underage if they have not yet reached the legal minimum age for employment. The minimum age for employment under international standards is not less than 15 years, or the age at which compulsory schooling is completed, whichever is higher. National laws should specify the minimum age for employment, which may be set temporarily at 14 in developing countries.\r\r\n\r\r\nChildren who are at least 14 years of age can work in an enterprise when they work in accordance with a government-approved training programme (apprenticeship).\r\r\n\r\r\nConsult applicable legal requirements before answering this question.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-chi-13',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4440,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
